/**
 * 帖子的tab字典，因为有好几个地方都要用到，所以单独提取出来
 */
export default {
  good: {
    name: '精华',
    color: 'magenta'
  },
  job: {
    name: '招聘',
    color: 'blue'
  },
  ask: {
    name: '问答',
    color: 'geekblue'
  },
  share: {
    name: '分享',
    color: 'green'
  }
}
